/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBatteryExclamation = createReactComponent("outline", "battery-exclamation", "IconBatteryExclamation", [["path", { "d": "M9 17h8c1.105 0 2 -.895 2 -2v-.5c0 -.276 .224 -.5 .5 -.5s.5 -.224 .5 -.5v-3c0 -.276 -.224 -.5 -.5 -.5s-.5 -.224 -.5 -.5v-.5c0 -1.105 -.895 -2 -2 -2h-11c-1.105 0 -2 .895 -2 2v3", "key": "svg-0" }], ["path", { "d": "M5 16v3", "key": "svg-1" }], ["path", { "d": "M5 22v.01", "key": "svg-2" }]]);

export { IconBatteryExclamation as default };
//# sourceMappingURL=IconBatteryExclamation.mjs.map
